var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-row',[_c('b-col',[_c('h5',[_vm._v(_vm._s(_vm.item.name))])]),_c('b-col',[_c('h5',[_vm._v(_vm._s(_vm.getPosetive.toLocaleString())+" ریال")])])],1),_vm._l((_vm.getChild),function(x){return _c('div',{key:x.id},[_c('BalanceItem',{staticClass:"ml-5",attrs:{"item":x,"list":_vm.list}}),_c('hr')],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }